//#region package/amsart/provides.ts
var macros = {
	author: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	},
	address: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	},
	curraddr: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	},
	email: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	},
	title: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	},
	urladdr: {
		signature: "o m",
		renderInfo: {
			breakAround: true,
			inParMode: true
		}
	}
};
var environments = {};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map